
import { defineComponent, onBeforeMount, ref } from 'vue';
import Moment from 'moment';
import momentTimezone from 'moment-timezone';
import Generic from '@/components/global/GenericModal.vue';
import GenericV2 from '@/components/global/GenericModalV2.vue';
import Greetings from '@/components/global/Greetings.vue';
// import store from '@/store';
// eslint-disable-next-line
import { fetchInitialData } from '@/utils/learner_landing_service';
import axios, { AxiosError } from 'axios';
import ErrorMessage from '@/components/global/ErrorMessage.vue';
import SolidifyLanding from '@/components/global/SolidifyLanding.vue';
import CohortLanding from '@/components/global/CohortLanding.vue';
// eslint-disable-next-line
import { postApi } from '@/utils/ApiCalls';
// eslint-disable-next-line
import router from '../router';
// import { $http } from '@genpact/genome.mfe.shared-components'; // eslint-disable-line
// import {
//   // fetchInitialData,
//   // fetchSystemSetting,
//   getProfileInfo,
// } from '../utils/learner_landing_service';
// console.log($http.get('/api/genome/rbac/v1/self').then(({ data }) => console.log(data))); // eslint-disable-line
// eslint-disable-next-line
export default defineComponent({
  name: 'LearnerHome',
  components: {
    Generic,
    ErrorMessage,
    SolidifyLanding,
    CohortLanding,
    GenericV2,
    Greetings,
  },
  // eslint-disable-next-line vue/require-prop-types
  // props: ['query'],
  props: {
    query: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props) {
    const skillId = ref();
    const proficiencyId = ref();
    const programId = ref();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const initialData = ref();
    const errorResponse = ref();
    const showErrorMessage = ref(false);
    // const videoUrl = ref();
    const helpmateLink = ref();
    const modalVisible = ref(false);
    const modalV2Visible = ref(false);
    const modalMessage = ref();
    const renderReady = ref();
    const modalCloseVisible = ref(false);
    const modalButtonVisible = ref(false);
    const modalButtonLink = ref();
    const diffAccessMsg = ref(
      'It looks like you have not tagged yourself correctly in <a target="_blank" href="http://genome.genpact.com/#Myprofile"><strong>My Profile</strong></a>. The learners in band 5 and 4A in operations need to start at Beginner proficiency level and subsequently move to higher levels of proficiency. You should be at a beginner for all skills unless you have already completed a Beginner Wave. Check on <a href="https://genome.genpact.com/" target="_blank"><strong>Genome</strong></a> now to see which skills you need to update. Once you fix your My Profile, you will get access to Solidify again within 48 hours.',
    );
    onBeforeMount(async () => {
      // await getProfileInfo();
      try {
        // eslint-disable-next-line prefer-destructuring
        skillId.value = props.query.skill_id;
        // eslint-disable-next-line prefer-destructuring
        proficiencyId.value = props.query.proficiency_id;
        // eslint-disable-next-line prefer-destructuring
        programId.value = props.query.program_id;
        renderReady.value = false;
        const tz = momentTimezone.tz.guess();
        // console.log('timezone', tz);
        const initialParam = { skill: skillId.value, proficiency: proficiencyId.value, program_id: programId.value, timezone: tz };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const res: any = await fetchInitialData('/learner/journey/stat', initialParam);
        initialData.value = res.data;
        if (initialData.value) {
          // console.log('in learner landing screen');
          // console.log(`initialData.value ${JSON.stringify(initialData.value)}`);
          if (initialData.value.userObj) {
            if (initialData.value.userObj.last_accessed_on) {
              //  console.log('inside last accessed');
              localStorage.setItem('lastAccess', Moment(initialData.value.userObj.last_accessed_on).format('MMM Do YYYY, h:mm a'));
            }
            if (initialData.value.userObj.user_fullName) {
              localStorage.setItem('userName', initialData.value.userObj.user_fullName);
            }
            if (initialData.value.userObj.user_email) {
              localStorage.setItem('email', initialData.value.userObj.user_email);
            }
            if (initialData.value.userObj.user_key) {
              localStorage.setItem('user_key', initialData.value.userObj.user_key);
            }
          }
          if (initialData.value.system_under_maintainence) {
            // console.log('inside learner under manitenance');
            // for now moving it to error page, later will move to system under maintennace screen
            localStorage.setItem('errorMsg', initialData.value.maintenance_message);
            router.push({ path: '/solidify/systemUnderMaintenance' }).catch();
            return;
          }
          if (initialData.value.is_learner_not_allowed) {
            console.log('inside learner not allowed');
            modalVisible.value = true;
            modalMessage.value = 'Please contact helpmate.';
            renderReady.value = true;
            return;
          }
          if (initialData.value.isSkillSunet) {
            console.log('inside skill is sunset');
            renderReady.value = true;
            errorResponse.value = initialData.value.message;
            showErrorMessage.value = true;
            return;
          }
          if (initialData.value.is_learner_not_in_program) {
            // console.log('inside is_learner_in_program');
            renderReady.value = true;
            errorResponse.value = 'You have not been assigned to this program';
            showErrorMessage.value = true;
            return;
          }
          if (initialData.value.is_cohort_not_started) {
            // console.log('inside is_learner_in_program');
            renderReady.value = true;
            errorResponse.value = `You may not start Solidify for this cohort until ${initialData.value.cohort_startDate}. Please log in again on that date.`;
            showErrorMessage.value = true;
            return;
          }
          if (initialData.value.plagiarism_reEvalution_inProgress === true) {
            // console.log('inside is_learner_plagiarized');
            renderReady.value = true;
            errorResponse.value = 'You may not start Solidify until the plagiarism status is complete.';
            showErrorMessage.value = true;
            return;
          }
          if (initialData.value.cohortFailedData) {
            // console.log('inside cohortFailedData if');
            if (initialData.value.cohortFailedData.learner_status === 'Fail' && initialData.value.cohortFailedData.linked_program_name !== 'infinity') {
              // console.log('inside learner_status if');
              router.push({ path: '/solidify/done', query: { learner_task_id: initialData.value.cohortFailedData.learner_task_id } });
            }
          }
          // console.log(`initialData.value.skill ${initialData.value.skill}`);
          if (!initialData.value.skill) {
            // console.log('inside no skill');
            renderReady.value = true;
            errorResponse.value = 'Skill Not Found';
            showErrorMessage.value = true;
            return;
          }
          // console.log(`initialData.value.proficiency ${initialData.value.proficiency}`);
          if (!initialData.value.proficiency) {
            // console.log('inside no prof');
            renderReady.value = true;
            errorResponse.value = 'Proficiency Not Found';
            showErrorMessage.value = true;
            return;
          }
          // console.log(`initialData.value.userObj ${initialData.value.userObj}`);
          if (!initialData.value.userObj) {
            // console.log('inside no user obj');
            renderReady.value = true;
            errorResponse.value = 'User Profile Not Found';
            showErrorMessage.value = true;
            return;
          }
          // console.log(`!initialData.value.userObj.diff_access_status ${initialData.value.userObj.diff_access_status}`);
          if (initialData.value.userObj.diff_access_status === 'suspended') {
            // console.log('inside suspended');
            renderReady.value = true;
            errorResponse.value = diffAccessMsg.value;
            showErrorMessage.value = true;
            return;
          }
          if (!initialData.value.userObj.diff_access_status) {
            initialData.value.userObj.diff_access_status = 'active';
          }
          if (initialData.value.learnerData && initialData.value.learnerData.technical_hold) {
            modalVisible.value = true;
            modalMessage.value = `Your submission for ${initialData.value.skill}-${initialData.value.proficiency} is under evaluation. This process may take up to 7 business days.`;
            renderReady.value = true;
            return;
          }
          // console.log(`initialData.value.reReviewStatus ${initialData.value.reReviewStatus}`);
          if (programId.value === 'infinity' && initialData.value.reReviewStatus) {
            if (!initialData.value.reReviewStatus.is_plagiarised || !(initialData.value.reReviewStatus.plagiarism_reevaluation_requested && initialData.value.reReviewStatus.plagiarism_reevaluation_status === 'complete')) {
              // console.log(`initialData.value.reReviewStatus.request_for_re_review ${initialData.value.reReviewStatus.request_for_re_review}`);
              if (!initialData.value.reReviewStatus.request_for_re_review) {
                modalVisible.value = true;
                modalMessage.value = '<strong>Choose how you’d like to continue: </strong>';
                modalCloseVisible.value = true;
                modalButtonVisible.value = true;
                modalButtonLink.value = initialData.value.reReviewStatus.learner_task_id;
              }
              // console.log(`initialData.value.reReviewStatus.re_review_status ${initialData.value.reReviewStatus.re_review_status}`);
              if (programId.value === 'infinity') {
                if (initialData.value.reReviewStatus.re_review_status === 'Re-review Accepted Proxy Assigned' || initialData.value.reReviewStatus.re_review_status === 'Re-review Accepted Proxy Unavailable') {
                  // console.log('inside nrereview is in progeress');
                  renderReady.value = true;
                  errorResponse.value = 'Your re-review is underway — we’ll notify you once it’s complete. ';

                  showErrorMessage.value = true;
                  const learner_task_id_for_routing = initialData.value.reReviewStatus.learner_task_id;

                  if (learner_task_id_for_routing) {
                    console.log(`learner task id`, learner_task_id_for_routing);
                    router.push({ path: '/solidify/rereview', query: { learner_task_id: learner_task_id_for_routing } });
                  }

                  return;
                }
              }
            }
          }
          // console.log(`initialData.value.learnerData ${initialData.value.learnerData}`);
          renderReady.value = true;
          helpmateLink.value = initialData.value.systemSetting.helpmate_link;
          // console.log('before setting local storage');
          localStorage.setItem('skillId', skillId.value);
          localStorage.setItem('profId', proficiencyId.value);

          localStorage.setItem('programId', programId.value);

          localStorage.setItem('skillName', initialData.value.skill);

          localStorage.setItem('proficiency', initialData.value.proficiency);

          localStorage.setItem('helpmateLink', helpmateLink.value);

          localStorage.setItem('programName', initialData.value.program_details.program_name);

          localStorage.setItem('reviewerAssignmentStrategy', initialData.value.program_details.reviewer_strategy);

          localStorage.setItem('taskAssignmentStrategy', initialData.value.program_details.task_strategy);

          // console.log('after setting local storage');

          if (initialData.value.learnerData) {
            if (initialData.value.learnerData.learner_status === 'Registered') {
              router.push({ path: '/solidify/submitTask', query: { learner_task_id: initialData.value.learnerData.learner_task_id, program_id: programId.value } });
            } else if (initialData.value.learnerData.learner_status === 'Need Reviewer and Need Reviewee' || initialData.value.learnerData.learner_status === 'Need Reviewee') {
              router.push({ path: '/solidify/peerReview', query: { learner_task_id: initialData.value.learnerData.learner_task_id } });
            } else if (initialData.value.learnerData.learner_status === 'Passed' || initialData.value.learnerData.learner_status === 'Need Reviewer') {
              router.push({ path: '/solidify/done', query: { learner_task_id: initialData.value.learnerData.learner_task_id } });
            }
          }

          console.log(`initialData.value.existedLearnerDiffProf ${initialData.value.existedLearnerDiffProf}`);
          // if (initialData.value.existedLearnerDiffProf) {
          //   modalVisible.value = true;
          //   modalMessage.value = 'It appears that you have already started a learning task for this skill a different proficiency level. You must finish that task before registering a task at another proficiency level for the same skill.';
          // }
          if (initialData.value.existedLearnerDiffProf) {
            // eslint-disable-next-line prettier/prettier
            modalV2Visible.value = true;
          }

          // videoUrl.value = initialData.value.systemSetting.product_video_link;
          // helpmateLink.value = initialData.value.systemSetting.helpmate_link;
        }
      } catch (error) {
        console.log('inside catch error');
        console.log(JSON.stringify(error));
        renderReady.value = true;
        // localStorage.setItem('errorMsg', JSON.stringify(error));
        // router.push({ path: '/solidify/Error' });
        if (axios.isAxiosError(error)) {
          const err = error as AxiosError;
          // console.log(err.response?.data);
          errorResponse.value = (err.response?.data as { message: string })?.message;
          // console.log(`errorMessage.value ${errorMessage.value}`);
        } else {
          errorResponse.value = 'Something went wrong, please contact helpmate.';
        }
        showErrorMessage.value = true;
        // setTimeout(() => {
        //   showErrorMessage.value = false;
        // }, 2000);
      }
    });
    const closeModal = () => {
      modalVisible.value = false;
    };
    const closeModalV2 = () => {
      modalV2Visible.value = false;
    };
    const continueExistingJourney = async () => {
      console.log('continue');
      const data = initialData.value.existedLearnerDiffProf;
      router.replace({ path: '/solidify', query: { skill_id: data.skill, proficiency_id: data.proficiency, program_id: data.linked_program_name } });
      router.go(0);
      closeModalV2();
    };
    const terminateExistingJourney = async () => {
      try {
        renderReady.value = false;
        // console.log('learner journey terminated');
        // console.log(initialData.value.existedLearnerDiffProf);
        const data = { learner_task_id: initialData.value.existedLearnerDiffProf.learner_task_id };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const res: any = await postApi('/learner/terminate', data);
        closeModalV2();
        renderReady.value = true;
        console.log(res);
      } catch (error) {
        console.log('inside catch error');
        console.log(JSON.stringify(error));
        renderReady.value = true;
        if (axios.isAxiosError(error)) {
          const err = error as AxiosError;
          console.log(err.response?.data);
          errorResponse.value = err.response?.data;
        } else {
          errorResponse.value = 'There is an issue in requesting for review, please contact helpmate.';
        }
      }
    };
    return {
      skillId,
      proficiencyId,
      programId,
      initialData,
      // videoUrl,
      helpmateLink,
      modalVisible,
      modalV2Visible,
      modalMessage,
      renderReady,
      closeModal,
      closeModalV2,
      terminateExistingJourney,
      continueExistingJourney,
      modalCloseVisible,
      modalButtonVisible,
      modalButtonLink,
      showErrorMessage,
      errorResponse,
    };
  },
});
